import { CommonModule, registerLocaleData } from '@angular/common';
import { Component } from '@angular/core';
import { ApplicationModel, SideModel } from '../shared/interfaces/applicationModel'
import { FormsModule } from '@angular/forms';
import { LicenceApplicationService } from '../shared/services/licence-application.service';
import { CheckPriceModel, VehicleModel, VehiclePriceModel } from '../shared/interfaces/vehicleModel';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateDirective } from '../shared/translate.directive';
import { HttpClientModule } from '@angular/common/http';
import { LoginService } from '../shared/services/login.service';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import localeMk from '@angular/common/locales/mk';
import { EnglishToCyrillicDirective } from '../shared/cyrillic-input.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SocialAuthService } from '@abacritt/angularx-social-login';

registerLocaleData(localeMk);

@Component({
  selector: 'app-licence-application',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateDirective, HttpClientModule, EnglishToCyrillicDirective, MatIconModule, MatTooltipModule],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'mk-MK' }, provideNativeDateAdapter()],
  templateUrl: './licence-application.component.html',
  styleUrl: './licence-application.component.less'
})
export class LicenceApplicationComponent {

  constructor(public service: LicenceApplicationService, private router: Router, public loginService: LoginService,
    private activatedRoute: ActivatedRoute, private socialAuthService: SocialAuthService
  ) {
    activatedRoute.queryParams.subscribe((params) => {
      this.id = params['id']
    });
  }

  disableFields: any = false;
  id: any;
  currentStep = 1;
  // agreement = false
  agreement1 = false;
  agreement2 = false;
  agreement3 = false;
  agreement4 = false;
  cities: any;
  parkingTypes: any;
  permitTypes: any;
  garages: any;
  publicParkings: any;
  zones: any;
  description: any;
  user: any;
  hasErrors = false;
  hasErrorsFinal = false;
  errorsMessages: any;
  errorsMessagesFinal: any;
  permitModel: any;
  parkingTypeId: any;
  sideModel: SideModel = {
    ParkingTypeName: null,
    PermitTypeName: null,
    ZoneInfoName: null,
    ParkingGarageName: null,
    PublicParkingName: null,
    CityName: null,
    LotName: null
  }
  chosenPermit: any;
  chosenPermitLots: any;
  chosenparkingType: any;
  lotPrices: any;
  appModel: ApplicationModel = {
    Id: null,
    CityId: null,
    ParkingTypeId: null,
    PermitId: null,
    ParkingLotId: null,
    UserId: null,
    Vehicles: [{
      Registration: '',
      Model: '',
      Price: 0,
      FuelType: 0
    },],
    Name: null,
    Surname: null,
    Street: null,
    StreetNum: null,
    City: null,
    Phone: null,
    Email: null,
    AdditionalFiles: [],
    IdFiles: [],
    DriversLicences: [],
    TrafficLicences: [],
    AdditionMandatoryFiles: [],
    Price: null,
    IsIdFileOnAddress: false,
    IsTrafficeLicenceOnAddress: false,
    ParentApplicationId: null,
    IsAdmin: false,
    AdminId: null
  }
  priceModel: any = {
    PermitId: null,
    PriceType: null
  }

  firstStepValid = true;
  duplicateRegistration = true;
  forbiddenElectric = true;
  secondStepValid = true;
  thirdStepValid = true;
  fourthStepValid = true;
  VehiclePriceModel!: VehiclePriceModel[]
  newCar: CheckPriceModel = {
    Vehicles: [],
    AllowNewCar: true,
    PermitTypeId: 0,
    TotalAmount: 0
  }

  deleteCar: CheckPriceModel = {
    Vehicles: [],
    AllowNewCar: true,
    PermitTypeId: 0,
    TotalAmount: 0
  }
  parkingGarageIdDev: string = 'A24930F8-3F7D-4101-BD19-9B57965CF9E5';
  parkingGarageIdProd: string = '441F495F-A834-4F3C-87B3-F05E244C33C4';
  isSubmitting = false;
  selectedCityNameEN : string='';

  isAdmin: boolean = false;
  ngOnInit() {
    this.getAllCitties();
    // this.getParkingTypes();
    this.user = this.loginService.getUser();

    if (this.id) {
      this.disableFields = true;
      this.appModel = history.state.data;
      this.appModel.ParentApplicationId = this.id;
      var IdFiles = this.appModel.IdFiles;
      this.appModel.IdFiles = [];
      IdFiles.forEach(async (tl: { name: any; Path: string; }) => {
        const url = tl.Path.replace(/\\/g, "/");
        const response = await fetch(url);
        const blob = await response.blob();
        const file = new File([blob], tl.name, { type: blob.type || "application/pdf" });
        this.appModel.IdFiles.push(file);
      });


      var DriversLicences = this.appModel.DriversLicences;
      this.appModel.DriversLicences = [];
      DriversLicences.forEach(async (tl: { name: any; Path: string; }) => {

        const url = tl.Path.replace(/\\/g, "/");
        const response = await fetch(url);
        const blob = await response.blob();
        const file = new File([blob], tl.name, { type: blob.type || "application/pdf" });
        this.appModel.DriversLicences.push(file);
      });

      var TrafficLicences = this.appModel.TrafficLicences;
      this.appModel.TrafficLicences = [];
      TrafficLicences.forEach(async (tl: { name: any; Path: string; }) => {

        const url = tl.Path.replace(/\\/g, "/");
        const response = await fetch(url);
        const blob = await response.blob();
        const file = new File([blob], tl.name, { type: blob.type || "application/pdf" });
        this.appModel.TrafficLicences.push(file);
      });

      var AdditionMandatoryFiles = this.appModel.AdditionMandatoryFiles;
      this.appModel.AdditionMandatoryFiles = [];
      AdditionMandatoryFiles.forEach(async (tl: { name: any; Path: string; }) => {

        const url = tl.Path.replace(/\\/g, "/");
        const response = await fetch(url);
        const blob = await response.blob();
        const file = new File([blob], tl.name, { type: blob.type || "application/pdf" });
        this.appModel.AdditionMandatoryFiles.push(file);
      });

      var AdditionalFiles = this.appModel.AdditionalFiles;
      this.appModel.AdditionalFiles = [];
      AdditionalFiles.forEach(async (tl: { name: any; Path: string; }) => {

        const url = tl.Path.replace(/\\/g, "/");
        const response = await fetch(url);
        const blob = await response.blob();
        const file = new File([blob], tl.name, { type: blob.type || "application/pdf" });
        this.appModel.AdditionalFiles.push(file);
      });
      this.appModel;
      this.parkingTypeId = history.state.data.ParkingTypeId;
       this.getAllParkingTypesByCityId();
      this.getPermitTypes();
      this.permitModel = history.state.data.PermitTypeId;
      
    }

    if (this.user) {
      this.isAdmin = this.loginService.isAdmin();
      if (this.isAdmin) {
        this.appModel.IsAdmin = this.isAdmin
        this.appModel.AdminId = this.user.AdminId;
      }
      this.appModel.UserId = this.user.Id;

    }

  }

  validForm() {
    if (this.isAdmin) {
      return this.appModel.CityId &&
        this.appModel.PermitId &&
        (this.appModel.ParkingLotId) &&
        this.appModel.Name &&
        this.appModel.Surname &&
        this.appModel.Street &&
        this.appModel.StreetNum &&
        this.appModel.City &&
        this.appModel.Phone &&
        this.agreement1 && this.agreement2 && this.agreement4 &&
        this.firstStepValid &&
        this.secondStepValid &&
        this.thirdStepValid;
    }
    else {
      return this.appModel.CityId &&
        this.appModel.PermitId &&
        (this.appModel.ParkingLotId) &&
        this.appModel.Name &&
        this.appModel.Surname &&
        this.appModel.Street &&
        this.appModel.StreetNum &&
        this.appModel.City &&
        this.appModel.Phone &&
        this.appModel.Email &&
        this.agreement1 && this.agreement2 && this.agreement4 &&
        this.firstStepValid &&
        this.secondStepValid &&
        this.thirdStepValid;
    }
  }

  logout() {
    this.loginService.isLoggingOut = true;

    this.socialAuthService.signOut(true)
      .then(() => this.finalizeLogout())
      .catch(() => this.finalizeLogout());
    this.loginService.logout();
    this.router.navigateByUrl('/login');
  }
  private finalizeLogout() {
    this.loginService.logout();
    this.router.navigateByUrl('/login').then(() => {
      setTimeout(() => {
        this.loginService.isLoggingOut = false;
      }, 500);
    });
  }

  validateFirstStep() {

    this.errorsMessages = null;

    const forbiddenElectricConst =
      ((this.appModel?.ParkingTypeId?.toLowerCase() === this.parkingGarageIdDev.toLowerCase()) || (this.appModel?.ParkingTypeId?.toLowerCase() === this.parkingGarageIdProd.toLowerCase())) &&
      (this.appModel?.Vehicles?.some(v => v.FuelType === '3' || v.FuelType === '6'));

    if (this.appModel.CityId
      && this.appModel.PermitId
      && (this.appModel.ParkingLotId)
      && !forbiddenElectricConst
      && this.appModel.Vehicles.every(vehicle => vehicle.Registration.trim() !== '' && vehicle.Model.trim() !== "" && vehicle.FuelType != 0)
      && new Set(this.appModel.Vehicles.map(v => v.Registration.trim())).size === this.appModel.Vehicles.length) {

      this.firstStepValid = true;
      this.goToStep(2)
    }
    else {
      const registrations = this.appModel.Vehicles.map(v => v.Registration?.trim()).filter(r => r !== '');
      if (!(new Set(registrations).size === registrations.length)) {
        this.duplicateRegistration = false;
      }
      else {
        this.duplicateRegistration = true;
      }
      if (forbiddenElectricConst) {
        this.forbiddenElectric = false;
      }
      this.firstStepValid = false;
    }


    return this.firstStepValid;
  }
  validateSecondStep() {
    if (this.isAdmin) {
      if (this.appModel.Name && this.appModel.Surname && this.appModel.Street
        && this.appModel.StreetNum && this.appModel.City
        && this.appModel.Phone && this.emailValid) {
        this.secondStepValid = true;
        this.goToStep(3);
      }
      else {
        this.secondStepValid = false;
      }
    }
    else {
      if (this.appModel.Name && this.appModel.Surname && this.appModel.Street
        && this.appModel.StreetNum && this.appModel.City
        && this.appModel.Phone && this.appModel.Email && this.emailValid) {
        this.secondStepValid = true;
        this.goToStep(3);
      }
      else {
        this.secondStepValid = false;
      }
    }

    return this.secondStepValid;
  }
  validateThirdStep() {
    if (this.appModel.IdFiles.length != 0 && this.appModel.DriversLicences.length != 0 && this.appModel.TrafficLicences.length != 0) {
      if (this.chosenPermit.AdditionInfoForDocuments?.trim() && this.appModel.AdditionMandatoryFiles.length != 0) {
        this.thirdStepValid = true;
        this.goToStep(4);
        return;
      }
      else if (this.chosenPermit.AdditionInfoForDocuments?.trim() && this.appModel.AdditionMandatoryFiles.length == 0) {
        this.thirdStepValid = false;
        return;
      }
      this.thirdStepValid = true;
      this.goToStep(4);
    }
    else {
      this.thirdStepValid = false;
    }
    return this.thirdStepValid;
  }

  goToStep(step: any) {
    this.currentStep = step;

  }

  addNewVehicle() {
    this.firstStepValid = true;
    this.newCar.Vehicles = [];
    this.errorsMessages = null;
    this.appModel.Vehicles.forEach(vehicle => {
      // if(vehicle.Model != ''  && vehicle.Registration != '')
      // {
      this.newCar.Vehicles.push(vehicle);
      // }
    });
    this.newCar.Vehicles.push({
      Registration: '',
      Model: '',
      Price: 0,
      FuelType: 0
    }
    )
    this.newCar.PermitTypeId = this.chosenPermit.PermitTypeId;
    this.checkPrice();

  }

  checkPrice() {
    this.service.checkPriceModel(this.newCar).subscribe(res => {
      this.errorsMessages = null;
      this.newCar.AllowNewCar = res.AllowNewCar;
      this.appModel.Price = res.TotalAmount;
      if (res.AllowNewCar == false) {
        // alert("")
      }
      else {
        this.appModel.Vehicles.push({
          Registration: '',
          Model: '',
          Price: 0,
          FuelType: 0
        }
        )
      }
    },
      error => {
        this.hasErrors = true;
        this.errorsMessages = error.error.errors[0].Errors[0];
      })
  }


  onCityChange() {
    this.sideModel.CityName = this.cities.find((x: { Id: any; }) => x.Id === this.appModel.CityId).Name;
    this.selectedCityNameEN = this.cities.find((x: { Id: any; }) => x.Id === this.appModel.CityId).NameEN;
    this.sideModel.ParkingTypeName = "";
    this.appModel.PermitId = null;
    this.sideModel.PermitTypeName = "";
    this.appModel.ParkingLotId = null;
    this.sideModel.ZoneInfoName = "";
    this.sideModel.ParkingGarageName = "";
    this.sideModel.PublicParkingName = "";
    this.chosenPermitLots = [];
    this.newCar.AllowNewCar = true;
    this.duplicateRegistration = true;
    this.appModel.Vehicles = [];
    this.appModel.Vehicles.push({
      Registration: '',
      Model: '',
      Price: 0,
      FuelType: 0
    }
    )
    this.appModel.Price = 0;
    this.appModel.ParkingTypeId = null;
    this.getAllParkingTypesByCityId();
    this.onParkingChange(null)
  }

  onParkingChange(parking: any) {
    this.permitTypes = [];
    this.forbiddenElectric = true;
    this.firstStepValid = true;
    this.sideModel.ParkingTypeName = parking?.Name;
    this.zones = [];
    this.garages = [];
    this.chosenPermitLots = [];
    this.publicParkings = [];
    this.appModel.PermitId = null;
    this.sideModel.PermitTypeName = "";
    this.appModel.ParkingLotId = null;
    this.sideModel.ZoneInfoName = "";
    this.sideModel.ParkingGarageName = "";
    this.sideModel.PublicParkingName = "";
    this.errorsMessages = "";
    this.duplicateRegistration = true;
    this.getPermitTypes();
    this.appModel.Price = 0;
    this.description = null;
    this.newCar.AllowNewCar = true;
    this.appModel.Vehicles = [];
    this.appModel.Vehicles.push({
      Registration: '',
      Model: '',
      Price: 0,
      FuelType: 0
    }
    )
  }
  onPermitTypeChange() {
    if (!this.id) {
      this.appModel.ParkingLotId = null;
      this.appModel.Vehicles = [];
      this.appModel.Vehicles.push({
        Registration: '',
        Model: '',
        Price: 0,
        FuelType: 0
      }
      )
    }
    this.duplicateRegistration = true;
    this.sideModel.ZoneInfoName = "";
    this.sideModel.ParkingGarageName = "";
    this.sideModel.PublicParkingName = "";
    this.chosenPermit = this.permitTypes.find((p: { PermitTypeId: any; }) => p.PermitTypeId === parseInt(this.permitModel));
    if (this.chosenPermit) {
      this.sideModel.PermitTypeName = this.chosenPermit.Name;
      this.chosenPermitLots = this.chosenPermit.d.filter((x: { ParkingTypeName: string; }) => x.ParkingTypeName != null);
      let chosenPermitLots = this.chosenPermitLots.find((p: { PermitId: any; }) => p.PermitId === this.appModel.PermitId);
      if (chosenPermitLots) {
        this.sideModel.LotName = chosenPermitLots.ParkingTypeName;
      }
    }
    this.newCar.AllowNewCar = true;

  }

  onLotChange(lot: any) {
    this.duplicateRegistration = true;
    this.sideModel.LotName = lot.ParkingTypeName;
    this.appModel.PermitId = lot.PermitId;
    if ((this.appModel.Vehicles.length == 1)) {
      if (lot.Prices) {
        this.lotPrices = lot.Prices;
        this.appModel.Price = lot.Prices[0].Price;
      }
      else {
        this.appModel.Price = 0;
      }
    }
  }


  removeIdFile() {

    this.appModel.IdFiles = []
  }
  removeDriverLicence() {

    this.appModel.DriversLicences = [];
  }
  removeTrafficeLicence() {

    this.appModel.TrafficLicences = [];
  }
  removeAdditionMandatoryFile() {
    this.appModel.AdditionMandatoryFiles = [];
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const target = event.currentTarget as HTMLElement;
    target.classList.add('dragging');
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove('dragging');
  }

  onDrop(event: DragEvent, doc: string): void {
    event.preventDefault();
    event.stopPropagation();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove('dragging');

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const mockEvent = {
        target: {
          files: files
        }
      };
      this.multipleFilesSelect(mockEvent, doc);
    }
  }

  getFileSize(bytes: number): string {
    const mb = bytes / (1024 * 1024);
    return mb.toFixed(2) + 'MB';
  }

  onFileSelected(event: any, doc: any) {

    const file: File = event.target.files[0];

    if (file.type.match(/pdf|jpeg|jpg/) && file.size < 10 * 1024 * 1024) {

      const formData = new FormData();

      formData.append("file", file);

      if (doc == 'id') {
        this.appModel.IdFiles = file;
      }

      if (doc == 'driver') {
        this.appModel.DriversLicences = file;
      }

      if (doc == 'trafic') {
        this.appModel.TrafficLicences = file;
      }
      if (doc == 'additionMandatory') {
        this.appModel.AdditionMandatoryFiles = file;
      }
    }

  }
  removeIdFiles(i: any) {
    this.appModel.IdFiles.splice(i, 1);
  }
  removeDriversLicencesFiles(i: any) {
    this.appModel.DriversLicences.splice(i, 1);
  }
  removeTrafficLicencesFiles(i: any) {
    this.appModel.TrafficLicences.splice(i, 1);
  }
  removeAdditionMandatoryFiles(i: any) {
    this.appModel.AdditionMandatoryFiles.splice(i, 1);
  }
  removeAdditionalFiles(i: any) {
    this.appModel.AdditionalFiles.splice(i, 1);
  }



  multipleFilesSelect(event: any, doc: string): void {
    const files = event.target.files;

    if (!files || files.length === 0) return;

    // Determine target array
    let targetArray: File[] = [];
    let maxFiles = 2; // default limit

    if (doc === 'id') {
      targetArray = this.appModel.IdFiles;
    } else if (doc === 'driver') {
      targetArray = this.appModel.DriversLicences;
    } else if (doc === 'trafic') {
      targetArray = this.appModel.TrafficLicences;
    } else if (doc === 'additionMandatory') {
      targetArray = this.appModel.AdditionMandatoryFiles;
      maxFiles = 10;
    }
    else if (doc === 'other') {
      targetArray = this.appModel.AdditionalFiles;
      maxFiles = 999; // no limit for additional files
    }

    // Process each file
    for (let i = 0; i < files.length; i++) {
      const file: File = files[i];

      // Validate file type and size
      if (!file.type.match(/pdf|jpeg|jpg/) || file.size >= 10 * 1024 * 1024) {
        console.warn(`File ${file.name} rejected: invalid type or too large`);
        continue;
      }

      // Check for duplicates
      const alreadyExists = targetArray.some(
        f => f.name === file.name && f.size === file.size && f.lastModified === file.lastModified
      );

      if (alreadyExists) {
        console.warn(`File ${file.name} already exists`);
        continue;
      }

      // Check if limit reached
      if (targetArray.length >= maxFiles) {
        console.warn(`Maximum ${maxFiles} files allowed for ${doc}`);
        break;
      }

      // Add file to array
      targetArray.push(file);
    }
  }

  deleteVehicle(car: any) {
    this.errorsMessages = null;
    this.appModel.Vehicles.splice(car, 1);
    this.deleteCar.PermitTypeId = this.chosenPermit.PermitTypeId;
    this.deleteCar.Vehicles = this.appModel.Vehicles;
    this.service.checkPriceModel(this.deleteCar).subscribe(res => {
      this.newCar.AllowNewCar = res.AllowNewCar;
      this.appModel.Price = res.TotalAmount;
    },
      error => {
        this.hasErrors = true;
        this.errorsMessages = error.error.errors[0].Errors[0];
      })
    this.duplicateRegistration = true;
    if (!(new Set(this.appModel.Vehicles.map(v => v.Registration.trim())).size === this.appModel.Vehicles.length)) {
      this.duplicateRegistration = false;
    }
  }

  sendApp() {

    if (this.isSubmitting) return;

    var valid = this.validForm();
    if (valid) {
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('model', JSON.stringify(this.appModel));
      if (this.appModel.DriversLicences) {
        this.appModel.DriversLicences.forEach((file: any, index: any) => {
          formData.append(`DriversLicences[${index}]`, file, file.name);
        });
      }
      if (this.appModel.IdFiles) {
        this.appModel.IdFiles.forEach((file: any, index: any) => {
          formData.append(`IdFiles[${index}]`, file, file.name);
        });
      }
      if (this.appModel.AdditionalFiles) {
        this.appModel.AdditionalFiles.forEach((file: any, index: any) => {
          formData.append(`AdditionalFiles[${index}]`, file, file.name);
        });
      }
      if (this.appModel.TrafficLicences) {
        this.appModel.TrafficLicences.forEach((file: any, index: any) => {
          formData.append(`TrafficLicences[${index}]`, file, file.name);
        });
      }
      if (this.appModel.AdditionMandatoryFiles) {
        this.appModel.AdditionMandatoryFiles.forEach((file: any, index: any) => {
          formData.append(`AdditionMandatoryFiles[${index}]`, file, file.name);
        });
      }
      this.service.sendApp(formData).subscribe({
        next: res => {
          this.router.navigate(['success'], {
            state: { message: 'Успешно испратена апликација!' }
          });
        },
        error: error => {
          this.hasErrorsFinal = true;
          this.errorsMessagesFinal = error.error.errors[0].Errors[0];
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });

    }
    else {
      this.fourthStepValid = false;
    }
  }
  getAllCitties() {
    this.service.getAllCitties().subscribe(res => {
      this.cities = res;
    });

  }
  getAllParkingTypesByCityId() {
    this.service.getAllParkingTypesByCityId(this.appModel.CityId).subscribe(res => {
      this.parkingTypes = res;
      this.chosenparkingType = this.parkingTypes.find((p: { Id: any; }) => p.Id === this.appModel.ParkingTypeId);
      if (this.chosenparkingType) {
        this.sideModel.ParkingTypeName = this.chosenparkingType.Name;
      }

    })
  }

  getAllZones() {
    this.service.getAllZonesByCityId(this.appModel.CityId).subscribe(res => {
      this.zones = res;
    })
  }
  getAllParentZones() {
    this.service.getAllParentZonesByCityId(this.appModel.CityId).subscribe(res => {
      this.zones = res;
    })
  }
  getAllParkingGarages() {
    this.service.getAllParkingGarages().subscribe(res => {
      this.garages = res;
    });
  }

  getAllPublicParkings() {
    this.service.getAllPublicParkings().subscribe(res => {
      this.publicParkings = res;
    })
  }
  getPermitTypes() {
    if (this.appModel.ParkingTypeId != null && this.appModel.CityId !=null) {
      this.service.getAllPermitTypes(this.appModel.ParkingTypeId , this.appModel.CityId).subscribe(res => {
        this.permitTypes = res;
        this.onPermitTypeChange()
      })
    }
  }

  // getPriceForPermit(){
  //   this.priceModel.PermitId = this.appModel.PermitTypeId;
  //   this.priceModel.PermitId = this.appModel.ParkingLotId;
  //   this.priceModel.PriceType = 1;
  //   if(this.appModel.Vehicles[1]){
  //     this.priceModel.PriceType = 2;
  //   }

  //   this.service.getPriceForPermit(this.priceModel).subscribe(res=>{
  //     this.appModel.Price=res;
  //   })
  // }

  emailValid = true;
  emailChanged(e: any): void {
    this.appModel.Email = e;
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.emailValid = re.test(String(this.appModel.Email).toLowerCase());
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

}
